module.exports = __webpack_public_path__ + "static/media/Creek.46b4fa18.mp3";